<template>
    <eSesjaModal>
        <eSesjaModalHeader @close="$store.commit('setAddTranslationModalKeyStatus', false)">
            {{ $t('com.file.add-tranlsation-key-modal.title') }}
        </eSesjaModalHeader>
        <eSesjaModalBody>
            <label class="esesja-modal__wraper__body__label">{{ $t('com.file.add-tranlsation-key-modal.key') }}</label>
            <section class="esesja-modal__row">
                <input class="esesja-modal__wraper__body__input"
                    :class="{ 'input-has-error': model.key.length > maxChars || validation.key === false }"
                    :placecholder="$t('com.file.session-audio-video-link-modal.audio-label')" v-model="model.key" />
            </section>

            <label class="esesja-modal__wraper__body__label">{{ $t('com.file.add-tranlsation-key-modal.name') }}</label>
            <section class="esesja-modal__row">
                <input class="esesja-modal__wraper__body__input"
                    :class="{ 'input-has-error': model.name.length > maxChars || validation.audioLinkUri === false }"
                    :placecholder="$t('com.file.session-audio-video-link-modal.audio-label')" v-model="model.name" />
            </section>

            <label
                class="esesja-modal__wraper__body__label">{{ $t('com.file.add-tranlsation-key-modal.description') }}</label>
            <section class="esesja-modal__row">
                <input class="esesja-modal__wraper__body__input"
                    :class="{ 'input-has-error': model.description.length > maxChars || validation.description === false }"
                    :placecholder="$t('com.file.session-audio-video-link-modal.audio-label')"
                    v-model="model.description" />
            </section>
        </eSesjaModalBody>
        <eSesjaModalFooter>
            <eSesjaModalButtonCancel @close="$store.commit('setAddTranslationModalKeyStatus', false)">
                {{ $t('com.global.cancel') }}
            </eSesjaModalButtonCancel>
            <eSesjaModalButtonSave @click="addNewKey" :disabled="isSaveButtonDisabled">
                {{ $t('com.global.save') }}
            </eSesjaModalButtonSave>
        </eSesjaModalFooter>
    </eSesjaModal>
</template>
<script charset="utf-8">
import i18nService from '../../../../../services/i18n.service';
export default {
    name: "AddTranslationKeyModal",
    data() {
        return {
            model: {
                key: "",
                name: "",
                description: ""
            },
            validation: {
                key: true,
                name: true,
                description: true
            },
        }
    },
    methods:{
        async addNewKey(){
            try{
                this.$store.commit("showLoader");
                await i18nService.addTranslationKeys(this.model)
                this.$store.commit('setAddTranslationModalKeyStatus', false)
            }
            finally{
                this.$store.commit("hideLoader");
            }
        }
    }
}
</script>